// REDUX ACTION TYPES
export const TICK = 'TICK';
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const RESET = 'RESET';

export const SET_PIN_SUCCESS = 'SET_PIN_SUCCESS';
export const UPDATE_OWNER_SIGNATURE = 'UPDATE_OWNER_SIGNATURE';
export const SET_SLUG = 'SET_SLUG';
